import ImageIcon from 'images/icons/Image.svg';
import { ExtendedFullPageWidgetSettings } from 'types/settings';

import { Image } from 'components/Image';
import { useSettings } from 'components/SettingsProvider';
import { Stack } from 'components/Stack';
import { Text } from 'components/Text';

interface FooterProps {
  img: string | null;
  product_title: string;
}

export function Footer({ img, product_title }: FooterProps) {
  const { show_thumbnail } = useSettings<ExtendedFullPageWidgetSettings>();

  const imageMarkup = show_thumbnail && (
    <Image size="medium" source={img || ImageIcon} alt={product_title} />
  );

  return (
    <div>
      <Stack spacing="tight" alignment="center" wrap={false}>
        {imageMarkup}
        <Stack.Item fill>
          <Text underline truncate variation="semiStrong" size="small">
            {product_title}
          </Text>
        </Stack.Item>
      </Stack>
    </div>
  );
}
